import { DialogContent } from "@mui/material";
import React from "react";

const DialogBody = ({ children }) => {
  return <DialogContent dividers>{children}</DialogContent>;
};

export default DialogBody;
